<section class="healthcare-banner instool aashi">
    <div class="container">
        <div class="row zmc">
            <div class="col-lg-9 col-md-9 col-sm-12 col-12 service-heading">
                <div class="headtext">
                    <h1>A wellness application for your pets. All your pet’s requirements at one place. Give your pets a healthy, safe, and happy lifestyle. </h1><br>
                    <title>Pets and Joys Case Study - Pet Store E-Commerce Development | Vidhema</title>
                    <!-- <p >We design and build superior digital products, delegating seamless user experiences across all modern platforms and devices and helping brands to expand their business globally. -->
                    <!-- </p><a  routerLink="/getaquote.html"
                                            class="ar_contect-industries-header"><span
                                                    >Request a Free
                                                    Quote</span></a> -->
                </div>
            </div>
        </div>
    </div>

</section>
<div class="casestudy-details pt-120 pb-120">
    <div class="container logo-box">
        <img class="ilast-logo"
            src="https://firebasestorage.googleapis.com/v0/b/vidhema-72384.appspot.com/o/PetsandjoysLogo.jpg?alt=media&token=0b9ed60a-3d44-4ac2-b9ec-522d329eb3e8">
    </div>
    <div class="container">
        <div class="row gy-5">
            <div class="col-lg-8">
                <div class="case-details-single">
                    <h2>Pets and Joys
                    </h2>
                    <p class="para mb-30">
                        The main motto behind the Pets and Joys application is to make pets live healthy, safe, and
                        happy life. Pets and Joys is an application for pets to relish the life of pet owners.
                        The application allows pet owners to schedule an appointment with the veterinarian, order pet
                        food, and manage all the information about their pets.
                        Also, via this application vets can suggest and add medication and prescriptions for pets if
                        they want to.
                    </p>

                    <p class="para mb-30">
                        The client is from South India and wanted to have an app in the concern about pets and their
                        owners.
                    </p>

                    <img src="https://firebasestorage.googleapis.com/v0/b/vidhema-72384.appspot.com/o/two-golden-retriever-puppies-wearing-scarves.jpg?alt=media&token=108ffd85-2119-40cd-9414-fd4df433f576"
                        alt="image" class="img-fluid">
                </div>
            </div>
            <div class="col-lg-4">
                <div class="case-sidebar-area">
                    <ul class="case-info-list">
                        <li>
                            <span>
                                <img src="../../../assets/images/sidebar-arrow.svg" alt="image">Team Size :
                            </span>
                            <h5>
                                6 Members
                            </h5>
                            <h5>

                                Developers | Designers | QA | BA

                            </h5>

                        <li><span><img src="../../../assets/images/sidebar-arrow.svg" alt="image">Industry :</span>
                            <h5>Medical, Ecommerce
                            </h5>
                        </li>



                        <li><span><img src="../../../assets/images/sidebar-arrow.svg" alt="image">Duration :</span>
                            <h5> 1 Year</h5>
                        </li>
                        <!-- <li><span><img src="../../../assets/images/sidebar-arrow.svg" alt="image">Team:</span>
                           
                        </li> -->
                    </ul>
                </div>
            </div>
        </div>
    </div>
    <div class="container">
        <div class="row">
            <div class="col-12">
                <div class="case-details-single">

                    <div class="area">
                        <h4>Who is the client?</h4>
                        <p class="para">
                        
                            The Client is from South India and wanted to have an app where pet owners can effortlessly schedule an appointment with veterinarian doctors. 
                            This could improve the health of their pets and they can get timely medications and vaccinations.
                            
                        </p>

<p class="para" >
    The Pets and Joys client works with veterinary professionals to help pet owners manage their pets' medical care, pet adoptions, and more. 
</p>

                    </div>
                    <div class="area">
                        <h4>Purpose of the Client
                        </h4>

                        <p class="para">
                            The Pets and Joys application is a business app and was developed to take care of pets. 
                            This app can be used by veterinary professionals as well as delivery boys.
                             This specific application can be useful for both in terms of user experience for:


                        </p>


                        <li>
                            <span>Veterinarian</span>
                           
                        </li>

                        <li>
                            <span>Delivery of Pet Food and Products</span>
                           
                        </li>

                        <p class="para">
                            In the client's view, it is easier to locate doctors via the app or in person
                             but it becomes very difficult to find veterinarian doctors through the app or in person.
                        </p>

                        <p class="para">
                            As the app had a feature that businesses use to add products for the customers.
                             But, the client wanted to have an Admin Panel where vendors can list the products and services for the customers.
                        </p>

                        <p class="para">
                            The customer has to schedule an appointment 14 days in advance to visit the clinic or to take the consultation via the app for the health checkup of their pets.
                             Once the customer takes the consultation from the veterinarian regarding their pets, they have to make a payment before consulting for the second time.
                             Only after making the payment, the pet owners can take another consulting appointment with the veterinarian doctors.
                        </p>


                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="full-area-bg">
        <div class="container">
            <div class="row">
                <div class="col-xs-12 col-md-8">
                    <div class="case-details-single">
                        <div class="area">
                            <h4>Challenges
                            </h4>
                            <p class="para">
                                The main challenge faced by the client is that initially,
                                the application is used to provide the information through business to the customer.
                                 They wanted to convert it and have to create an Admin Panel to list out the products and send them to costumes.
                             
                            </p>
                            <p class="para">
                                The client wanted to have features such as
                                 </p>
                        </div>

                        <div class="list-title list-space"><img class="img-value"
                            src="../../../assets/images/list-arrow.svg" alt="image">
                        <p class="para">

                            UI/UX has to be effective and engaging.
                        </p>
                    </div>

                    <div class="list-title list-space"><img class="img-value"
                        src="../../../assets/images/list-arrow.svg" alt="image">
                    <p class="para">

                        The application has to work fast according to the user's requirements.
                    </p>
                </div>


                <div class="list-title list-space"><img class="img-value"
                    src="../../../assets/images/list-arrow.svg" alt="image">
                <p class="para">

                    The implemented features have to work accordingly with rapid action.
                </p>
            </div>

            
            <div class="list-title list-space"><img class="img-value"
                src="../../../assets/images/list-arrow.svg" alt="image">
            <p class="para">

                The application must include all the information about the pets and their owners and must save all the data.
            </p>
        </div>

        <div class="list-title list-space"><img class="img-value"
            src="../../../assets/images/list-arrow.svg" alt="image">
        <p class="para">
            The prescription or medication can be provided by veterinary professionals and must be sent to the pet owners.
               </p>
    </div>



                    </div>
                </div>
                <div class="col-xs-12 col-md-4">
                    <img src="assets/images/c-intro.svg" alt="Intro">
                </div>
            </div>
        </div>
    </div>
    <div class="container">
        <div class="row">
            <div class="col-lg-12">
                <div class="case-details-single">
                    <div class="area">
                        <h4>Solutions:</h4>
                        <p class="para">

                            The Pets and Joys client came across Vidhema Technologies to modify the application to make it user-friendly and engaging.
                             The client was searching for a company that could provide them with satisfactory solutions while adding new and useful features to it.
                             Our adroit developers executed everything according to the client by making the application intuitive, engaging, and user-centric.

                             </p>

                        <p class="para">

                            The application already had a feature for communication and food purchasing.
                             We gave the solution to have the one-to-one chat feature and to add the delivery by delivery boy option in the app.

                              </p>

                          <p class="para">
                            The features implemented by our team of prolific developers were:
                          </p>   

                          <div class="list-title list-space"><img class="img-value"
                            src="../../../assets/images/list-arrow.svg" alt="image">
                        <p class="para">

                            Remote Consulting

                        </p>
                        
                    </div>
                    <p>Here the customer can ask questions related to their pets' health and related to other concerns.
                        The veterinarian doctor will answer their questions in minimal time.  </p>

                        <div class="list-title list-space"><img class="img-value"
                            src="../../../assets/images/list-arrow.svg" alt="image">
                        <p class="para">

                            Food Delivery


                        </p>
                        
                    </div>
                    <p>
                        Customers can order pet food, pet medicines, and other pet stuff from the application and
                         the delivery boy will deliver the products to their doorstep.    
                    </p>

                    <div class="list-title list-space"><img class="img-value"
                        src="../../../assets/images/list-arrow.svg" alt="image">
                    <p class="para">

                        Adoption and Virtual Adoption


                    </p>
                    
                </div>
                <p>
                    Through the feature of Adoption, pet lovers can adopt their favorite pets via the application
                     and sign them in as their pet owners.
                </p>
                <p>
                    With the help of the Virtual Adoption feature, pet owners can make a virtual adoption of any pet they want. After the virtual adoption, here the pet owner does not have to bring the adopted pet to their home;
                     they can only have to pay the monthly amount to the charity or to the concerned person.
                </p>


                <div class="list-title list-space"><img class="img-value"
                    src="../../../assets/images/list-arrow.svg" alt="image">
                <p class="para">

                    Vaccination


                </p>
                
            </div>
            <p>
                With the help of this feature, the client will be notified about the vaccinations of their pets. They will get prior notification about their vaccinations and the pet owners can take their pets to the veterinarian on a timely basis.
                 Meanwhile, there will be no sacrifice for their health.
            </p>

            <div class="list-title list-space"><img class="img-value"
                src="../../../assets/images/list-arrow.svg" alt="image">
            <p class="para">

                Prescription and Medication


            </p>
            
        </div>
        <p>
            This feature is for doctors or vets, if they want to give any advice or medication for someone’s pet they can provide them with the help of this feature.
             It will be beneficial for pet owners as they can go through the prescription via the application at any time from anywhere.  
        </p>


                    </div>

                    <div class="area">
                        <h4>Results</h4>
                        <p class="para">
                            According to the client's requirements,
                             our team of developers implemented all the features accordingly.
                              The features that were modified worked well as per the client’s plans. 

                        </p>
                        <div class="list-title list-space"><img class="img-value"
                                src="../../../assets/images/list-arrow.svg" alt="image">
                            <p class="para">

                                As the application went live for the audience, the result was pretty good as there were many downloads done for the Pets and Joys app.
                            </p>
                        </div>
                        <div class="list-title list-space"><img class="img-value"
                                src="../../../assets/images/list-arrow.svg" alt="image">
                            <p class="para">

                                The reviews from the users were well related to the app and the pet lovers enjoyed browsing the app.    
                             </p>
                        </div>
                        <div class="list-title list-space"><img class="img-value"
                                src="../../../assets/images/list-arrow.svg" alt="image">
                            <p class="para">
                                Via the application, the users save a lot of time as they get notified when to visit the vet again. 
                            </p>
                        </div>

                        <div class="list-title list-space"><img class="img-value"
                                src="../../../assets/images/list-arrow.svg" alt="image">
                            <p class="para">
                                The application had a great number of downloads in the South region of India.

                            </p>
                        </div>

                        <div class="list-title list-space"><img class="img-value"
                                src="../../../assets/images/list-arrow.svg" alt="image">
                            <p class="para">
                                The UI/UX of the app was built as user-centric where users will be able to navigate it effortlessly.
                            </p>
                        </div>

                        <div class="list-title list-space"><img class="img-value"
                            src="../../../assets/images/list-arrow.svg" alt="image">
                        <p class="para">
                            The speed of the app was measured while keeping in mind the SEO and it had to be mobile responsive too. 

                        </p>
                    </div>

                    <div class="list-title list-space"><img class="img-value"
                        src="../../../assets/images/list-arrow.svg" alt="image">
                    <p class="para">
                        Implemented features worked effectively and smoothly.
                    </p>
                </div>


                    </div>
                </div>
            </div>
        </div>
    </div>


    <div class="container">
        <div class="row">
            <div class="col-lg-12">
                <div class="case-details-single">
                    <div class="area">
                        <h4>Technologies and Tools </h4>
                        <ul class="process-list half-description tech-des">
                            <li>
                                <div class="list-title  list-space"><img
                                        src="https://firebasestorage.googleapis.com/v0/b/vidhema-72384.appspot.com/o/angular-logo.svg?alt=media&token=1855b726-a6f4-4c76-985f-ead15082dc25"
                                        alt="image" class="tech-logo">
                                    <!-- <h5>Angular</h5> -->
                                </div>
                            </li>
                            <li>
                                <div class="list-title  list-space"><img
                                        src="https://firebasestorage.googleapis.com/v0/b/vidhema-72384.appspot.com/o/aws.png?alt=media&token=316590f4-daa3-48e4-ba31-6aaa67cd0962"
                                        alt="image" class="tech-logo">
                                    <!-- <h5>Ionic</h5> -->
                                </div>
                            </li>

                            <li>
                                <div class="list-title  list-space"><img
                                        src="https://firebasestorage.googleapis.com/v0/b/vidhema-72384.appspot.com/o/ionic-icon.svg?alt=media&token=571ee6a3-d940-499e-ae17-bfa2e88ca23b"
                                        alt="image" class="tech-logo">
                                    <!-- <h5>Ionic</h5> -->
                                </div>
                            </li>

                            <li>
                                <div class="list-title  list-space"><img
                                        src="https://firebasestorage.googleapis.com/v0/b/vidhema-72384.appspot.com/o/node%20js.png?alt=media&token=c37cf052-b478-49a4-b1b1-f21102accaa8"
                                        alt="image" class="tech-logo">
                                    <!-- <h5>Ionic</h5> -->
                                </div>
                            </li>

                            <li>
                                <div class="list-title  list-space"><img
                                        src="https://firebasestorage.googleapis.com/v0/b/vidhema-72384.appspot.com/o/MongoDB-Logo.png?alt=media&token=f5385b8c-1f9b-472c-a9c4-b705d63f9449"
                                        alt="image" class="tech-logo">
                                    <!-- <h5>Ionic</h5> -->
                                </div>
                            </li>

                        </ul>
                    </div>
                    <!-- <div class="area">
                        <h4>Website Features</h4>
                        <ul class="process-list half-description">
                            <li style="    max-width: 100%;display: block;flex: 0 0 100%;">
                                <div class="list-title  list-space">

                                    <p class="para">
                                        Navigation of the website was quite easy and hassle-free and kept with the
                                        step-by-step guide system. The users will get all the steps as they will apply
                                        to add the list of the products that they would like to add.
                                        The features and functionalities in the ZonSteps website were added to make
                                        businesses of every spectrum grow among the competitors.
                                    </p>

                                </div>

                                <div class="list-title list-space"><img class="img-value"
                                        src="../../../assets/images/list-arrow.svg" alt="image">
                                    <p class="para">
                                        Step-by-step guide system
                                    </p>
                                </div>

                                <div class="list-title list-space"><img class="img-value"
                                        src="../../../assets/images/list-arrow.svg" alt="image">
                                    <p class="para">
                                        Various categories available for every business industry
                                    </p>
                                </div>


                                <div class="list-title list-space"><img class="img-value"
                                        src="../../../assets/images/list-arrow.svg" alt="image">
                                    <p class="para">
                                        Easy navigation
                                    </p>
                                </div>

                                <div class="list-title list-space"><img class="img-value"
                                        src="../../../assets/images/list-arrow.svg" alt="image">
                                    <p class="para">
                                        Good UI/UX
                                    </p>
                                </div>

                                <div class="list-title list-space"><img class="img-value"
                                        src="../../../assets/images/list-arrow.svg" alt="image">
                                    <p class="para">
                                        There is a subscription for different phases of adding the businesses
                                    </p>
                                </div>

                            </li>

                        </ul>
                    </div>
                </div>
            </div>
        </div> -->
    </div>

</div>